var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-day",
    transform: "translate(-1465.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(25.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 35,
    transform: "translate(1440.000000, 3.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6959238,5.99771429 C11.200451,5.99771429 11.6864061,6.0772447 12.141936,6.22445253 L12.265442,6.2677088 C11.1840637,7.64977044 10.4857536,9.34604499 10.3303351,11.1967619 L10.3303351,11.1967619 L9.79793798,11.1967619 C8.48995285,11.1967619 7.27680507,11.6016988 6.27691884,12.2930147 C6.09614724,11.7955199 5.99771429,11.257215 5.99771429,10.6959238 C5.99771429,8.10121265 8.10121265,5.99771429 10.6959238,5.99771429 Z",
    id: "Combined-Shape",
    fill: "#FED100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 0,
    y: 9.89622857,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    transform: "translate(4.723126, 4.723160) rotate(45.000000) translate(-4.723126, -4.723160) ",
    x: 2.473983,
    y: 3.92346459,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 9.89622857,
    y: 0,
    width: 1.59939048,
    height: 4.49828571,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5810097,4.19942857 C22.2141974,4.19942857 24.5964777,5.51858873 26.0155606,7.59897917 C22.3513965,7.68210385 19.3703199,10.5126144 19.0676901,14.1018258 L19.0676901,14.1018258 L18.6583461,14.1018258 C16.0261492,14.1018258 13.8935619,16.2260163 13.8935619,18.8464177 C13.8935619,20.1025155 14.3835606,21.2444081 15.1835645,22.0930484 L9.79793798,22.0926095 C7.20262705,22.0926095 5.09942857,19.989611 5.09942857,17.3944 C5.09942857,14.8714726 7.08731104,12.8134143 9.58282788,12.7010245 L9.79793798,12.6961905 L11.7091096,12.6961905 L11.8245656,11.3222141 C12.1614373,7.31054293 15.5282542,4.19942857 19.5810097,4.19942857 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1792798,9.09653333 C28.5891614,9.09653333 30.7076541,10.6137551 31.4966534,12.8355084 L31.4966534,12.8355084 L31.9125949,14.006862 L33.1408268,13.815235 C33.3560448,13.7816478 33.5751613,13.7646543 33.7970767,13.7646543 C36.1110949,13.7646543 37.984381,15.6300434 37.984381,17.9281676 C37.984381,20.2260919 36.1110949,22.091581 33.7970767,22.091581 L33.7970767,22.091581 L18.6583461,22.091581 C16.8533339,22.091581 15.3929905,20.637635 15.3929905,18.8464177 C15.3929905,17.0553003 16.8530341,15.6012544 18.6583461,15.6012544 L18.6583461,15.6012544 L20.4458648,15.6012544 L20.5618206,14.2277778 C20.8053278,11.3393786 23.242699,9.09653333 26.1792798,9.09653333 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0919647,32.4890185 C21.0919647,34.0340297 19.8388395,35.2865524 18.2930286,35.2865524 C16.7472177,35.2865524 15.4940952,34.0340297 15.4940952,32.4890185 C15.4940952,32.0609816 15.5902586,31.6553362 15.762293,31.2925745 L17.3296957,27.3046942 C17.8612931,25.9522097 18.7227648,25.9512101 19.2546621,27.3046942 L20.8147675,31.2737816 C20.9977836,31.6527186 21.0925546,32.0682006 21.0919647,32.4890185 L21.0919647,32.4890185 Z M29.7886504,32.4890185 C29.7886504,34.0340297 28.5355252,35.2865524 26.9897143,35.2865524 C25.4439034,35.2865524 24.190781,34.0340297 24.190781,32.4890185 C24.190781,32.0609816 24.2869443,31.6553362 24.4589787,31.2925745 L26.0263814,27.3046942 C26.5579788,25.9522097 27.4194505,25.9512101 27.9513478,27.3046942 L29.5114533,31.2737816 C29.6944693,31.6527186 29.7892403,32.0682006 29.7886504,32.4890185 L29.7886504,32.4890185 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.0132a2cb32746d54ded2fba02ad71555.svg";
export { ForwardRef as ReactComponent };